let optimistDial = document.querySelector('#optimistDial');

window.addEventListener("scroll", function() {
    // optimistDial.style.transform = "rotate("+window.pageYOffset/6+"deg)";
});


